import React from 'react';
import {Outlet} from 'react-router-dom';
import IsMntnInqApi from 'Apis/IsMntnInqApi';


import"Assets/css/PopLayout.css";
import "Assets/css/PopUi.css";

const PopLayout = () => {
    // IsMntnInqApi("mgp")
    // .then((resp) => {
    // });
    return (
        <>
            <div className='popContainer'>
                <Outlet />
            </div>
        </>
    );
  }
  export default PopLayout;